var React = require('react');

function Right (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Composant_4_1","data-name":"Composant 4 – 1","transform":"translate(2.121 2.121)"},React.createElement("path",{"id":"Tracé_2","data-name":"Tracé 2","d":"M3329.306,2481.778l6.985,6.686-6.985,6.686","transform":"translate(-3329.306 -2481.778)","fill":"none","stroke":"#04152f","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3"})));
}

Right.defaultProps = {"width":"10.605","height":"17.614","viewBox":"0 0 10.605 17.614"};

module.exports = Right;

Right.default = Right;
